/**
 * /////////////////////////////////////////////////////////////////////////////
 *
 * https://keeptrack.space
 *
 * @Copyright (C) 2025 Kruczek Labs LLC
 *
 * KeepTrack is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * KeepTrack is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * KeepTrack. If not, see <http://www.gnu.org/licenses/>.
 *
 * /////////////////////////////////////////////////////////////////////////////
 */
import { SolarBody } from '@app/engine/core/interfaces';
import { settingsManager } from '../../../../settings/settings';
import { CelestialBody, PlanetColors } from './celestial-body';
export var VenusTextureQuality;
(function (VenusTextureQuality) {
    VenusTextureQuality["POTATO"] = "512";
    VenusTextureQuality["HIGH"] = "4k";
    VenusTextureQuality["ULTRA"] = "8k";
})(VenusTextureQuality || (VenusTextureQuality = {}));
export class Venus extends CelestialBody {
    RADIUS = 6051.8;
    NUM_HEIGHT_SEGS = 64;
    NUM_WIDTH_SEGS = 64;
    color = PlanetColors.VENUS;
    orbitalPeriod = 0.61519726 * 365 * 24 * 3600;
    meanDistanceToSun = 108209475;
    eci;
    textureQuality = VenusTextureQuality.POTATO;
    getTexturePath() {
        return `${settingsManager.installDirectory}textures/venus${this.textureQuality}.jpg`;
    }
    useHighestQualityTexture() {
        this.textureQuality = VenusTextureQuality.ULTRA;
        this.loadTexture();
    }
    getName() {
        return SolarBody.Venus;
    }
    draw(sunPosition, tgtBuffer = null) {
        if (!this.isLoaded_ || settingsManager.isDisablePlanets) {
            return;
        }
        super.draw(sunPosition, tgtBuffer);
    }
}
